import { useState } from 'react'
import {
  Avatar,
  Chip,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'

import { IUserSessionsDto } from 'src/types'
import { UserSessionItemCollapsed } from './user-session-item-collapsed.component'
import { CircleDownIcon, CircleUpIcon } from 'src/assets/icons'

import { useStyles } from './styles'
import { useStyles as useStyles2 } from '../user-sessions-table/styles'

interface IErrorLogsGridItemProps {
  item: IUserSessionsDto
}

const UserSessionsGridItem = ({ item }: IErrorLogsGridItemProps) => {
  const [toggle, setToggle] = useState(false)
  const classes = useStyles()
  const classes2 = useStyles2()

  const handleCollapse = () => {
    setToggle(!toggle)
  }

  return (
    <>
      <ListItemButton onClick={handleCollapse} disableGutters className={classes.listItemButton}>
        <ListItemIcon>{toggle ? <CircleUpIcon /> : <CircleDownIcon />}</ListItemIcon>
        <ListItemText className={classes.item} disableTypography>
          {item.user && (
            <Avatar
              src={item.user.image_small || item.user.image}
              alt={item.user.email}
              variant="circular"
            />
          )}
          <div className={classes.textWrapper}>
            <Typography className={`${classes.itemText} ${classes.itemPropertyText}`}>
              {item.user?.email ?? item.user_email}
            </Typography>
            <span className={classes.itemSubtext}>{item.user?.name}</span>
          </div>
        </ListItemText>
        <Chip
          className={item.active ? classes2.activeStatusChip : classes2.inactiveStatusChip}
          label={item.active ? 'online' : 'offline'}
        />
      </ListItemButton>
      <UserSessionItemCollapsed item={item} open={toggle} />
      <Divider />
    </>
  )
}

export { UserSessionsGridItem }
